module.exports = require("remarkable");


//////////////////
// WEBPACK FOOTER
// external "remarkable"
// module id = 263
// module chunks = 0